import { render, staticRenderFns } from "./CustomizeMetalT.vue?vue&type=template&id=bb7f25fa&scoped=true"
import script from "./CustomizeMetalT.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalT.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalT.vue?vue&type=style&index=0&id=bb7f25fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7f25fa",
  null
  
)

export default component.exports